import script from "./TableViolationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TableViolationsList.vue?vue&type=script&setup=true&lang=js"

import "./TableViolationsList.vue?vue&type=style&index=0&id=2991e684&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2991e684"]])

export default __exports__